import React from 'react';

export const MCSAPhishingHunt = () => {
    return (
        <iframe
            title="Phishing Hunt"
            src="/mcsa_htmls__TBD/phishing_hunt.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
